import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Card/card';
export var CardActions = function CardActions(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "className"]);

  return React.createElement("div", Object.assign({
    className: css(styles.cardActions, className)
  }, props), children);
};